"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parseURLParams;

var _fp = _interopRequireDefault(require("lodash/fp"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function parseURLParams(str) {
  if (!str) return null;
  return _fp["default"].fromPairs(_fp["default"].flow(_fp["default"].replace('?', ''), _fp["default"].split('&'), _fp["default"].map(function (s) {
    return s.split('=', 2);
  }))(str.slice(str.indexOf('?')))) || {};
}